import { Outlet } from "@vixi/router";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect } from "react";
import { RouteOptionsById, RouterIds } from "@vixi/router";
import { useGoBack, useUiStore } from "@vixi/ui";
import clsx from "clsx";

// Constants
const routeId = "/_app/premium" satisfies RouterIds;
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

export const PremiumRouteOptions: RouteOptionsById<typeof routeId> = {
  component: RouteComponent,
};

function RouteComponent() {
  useGoBack(null);

  const { setHeaderProps } = useUiStore((state) => state.header);

  useEffect(() => {
    setHeaderProps({
      className: clsx("bg-purple-100"),
    });

    return () => {
      setHeaderProps({
        className: clsx(""),
      });
    };
  }, []);

  return (
    <Elements stripe={stripePromise}>
      <Outlet />
    </Elements>
  );
}
